module.exports = __webpack_public_path__ + "si.38ccbaf679a55ada3fd7.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/si.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/si.svg
// module chunks = styles